import _ from 'lodash'

function getOffsetBottom() {
  const scrollY     = (window.scrollY || window.pageYOffset)
  const innerheight = (window.innerHeight || document.body.clientHeight)

  return scrollY + innerheight
}

function calculateStickyNavOffsetTop(el) {
  return el.offsetTop
}

function calculateStickyNavOffsetBottom(el) {
  return el.getBoundingClientRect().top - document.body.getBoundingClientRect().top
}

function updateVisibility(el) {
  if (_.chain(el.className).split(' ').includes('sticky-nav--position-bottom').value()) {
    if (getOffsetBottom() <= _.toNumber(el.dataset.stickyNavOffsetBottom)) {
      el.classList.add('sticky-nav--active')
    } else {
      el.classList.remove('sticky-nav--active');
    }
  } else {
    if (window.pageYOffset >= _.toNumber(el.dataset.stickyNavOffsetTop)) {
      el.classList.add('sticky-nav--active')
    } else {
      el.classList.remove('sticky-nav--active');
    }
  }
}

function watchDocChange(callback) {
  let lastHeight = document.body.clientHeight
  let newHeight  = null

  function run () {
    newHeight = document.body.clientHeight

    if (lastHeight != newHeight) {
      callback()
    }

    lastHeight = newHeight

    if (document.body.docChangeListener) {
      clearTimeout(document.body.docChangeListener)
    }

    document.body.docChangeListener = setTimeout(run, 1000)
  }

  run()
}

function unwatchDocChange() {
  if (!document.body.docChangeListener) {
    return
  }
  clearTimeout(document.body.docChangeListener)
}

export default {
  bind(el) {
    el.classList.add('sticky-nav')
    el.dataset.stickyNavOffsetTop    = calculateStickyNavOffsetTop(el)
    el.dataset.stickyNavOffsetBottom = calculateStickyNavOffsetBottom(el)

    window.addEventListener('scroll', () => {
      updateVisibility(el)
    })

    watchDocChange(() => {
      if (_.chain(el.className).split(' ').includes('sticky-nav--active').value()) {
        return
      }

      el.dataset.stickyNavOffsetTop    = calculateStickyNavOffsetTop(el)
      el.dataset.stickyNavOffsetBottom = calculateStickyNavOffsetBottom(el)

      updateVisibility(el)
    })
  },
  inserted(el) {
    el.dataset.stickyNavOffsetTop    = calculateStickyNavOffsetTop(el)
    el.dataset.stickyNavOffsetBottom = calculateStickyNavOffsetBottom(el)

    updateVisibility(el)
  },
  update(el) {
    el.dataset.stickyNavOffsetTop    = calculateStickyNavOffsetTop(el)
    el.dataset.stickyNavOffsetBottom = calculateStickyNavOffsetBottom(el)

    updateVisibility(el)
  },
  componentUpdated(el) {
    el.dataset.stickyNavOffsetTop    = calculateStickyNavOffsetTop(el)
    el.dataset.stickyNavOffsetBottom = calculateStickyNavOffsetBottom(el)

    updateVisibility(el)
  },
  unbind(el) {
    el.classList.remove('sticky-nav')
    el.classList.remove('sticky-nav--active')
    el.dataset.stickyNavOffsetTop    = null
    el.dataset.stickyNavOffsetBottom = null
    unwatchDocChange()
  }
}
